import { forwardRef, useId } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  help?: ReactNode;
  error?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, help, error, id, className, ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const helpId = `${inputId}-help`;
  const errId = `${inputId}-err`;
  return (
    <div className="field">
      <label className="field-label" htmlFor={inputId}>
        {label}
      </label>
      <input
        ref={ref}
        id={inputId}
        className={cn('field-control', className)}
        aria-invalid={error ? true : undefined}
        aria-describedby={[error ? errId : null, help ? helpId : null].filter(Boolean).join(' ') || undefined}
        {...rest}
      />
      {help && !error ? (
        <div id={helpId} className="field-help">
          {help}
        </div>
      ) : null}
      {error ? (
        <div id={errId} className="field-error" role="alert">
          {error}
        </div>
      ) : null}
    </div>
  );
});
